export default __webpack_public_path__ + "static/php-c07c7d6c1d35e9e4c57854cee6bf44e0.png";